import {Tooltip} from 'react-tooltip'
import RankIcon from "../rank-icon";

const urlRegex = /(https?:\/\/[^\s]+)/g;
const detectLinks = (text) => {
    const parts = text.split(urlRegex);

    return parts.map((part, index) => {
        // If it's a URL, render an <a> tag
        if (urlRegex.test(part)) {
            return (
                <a href={part} key={index} className="link-underline" target="_blank" rel="noopener noreferrer">
                    {part}
                </a>
            );
        }
        // Otherwise, render plain text
        return part;
    });
};

const ChatMessage = props => {


    const {message, handleUserDetail} = props
    return (
        <div className="chat__message">
                <span className="chat__user">


                              <Tooltip className="tooltip-me" anchorSelect={`#rank-tooltip1-${message.id}`}>
                                        <span className="xtable__coin gap-2">
                                            {/*<SvgIcon id={message?.rank}/>*/}
                                            {/*<RankIcon icon={message.ranki}/>*/}
                                            {/*{t(`modals.vip.progress.${message?.rank}`)}*/}
                                            {message?.rank?.toUpperCase() || message?.username?.toUpperCase()}
                                        </span>
                              </Tooltip>

                    {
                        message.ranki && <span id={`rank-tooltip1-${message.id}`}>
                                  <RankIcon icon={message.ranki}/>
                               </span>
                    }


                    <button className={`chat__name ${message?.operator_id ? 'colored' : ''}`} type="button"
                            onClick={e => (!message?.operator_id) && handleUserDetail(message)}>
                              {message.username}: {" "}
                    </button>
                </span>

            {/*<span>{message.message}</span>*/}
            <span>{detectLinks(message.message)}</span>
        </div>
    )
}

export default ChatMessage
